import React, { useState, useEffect } from "react";
import InputField from "../../reusables/input";
import Spinner from "../../reusables/spinner";
import { motion } from "framer-motion";
import { connect } from "react-redux";
import {
  update_platform_fees,
  get_settings,
} from "../../../redux/actions/adminActions";
import {
  animationValues,
  transitionValues,
} from "../../../utils/pageTransitions";

function Fees({ updatePlatformFees, settings, accessToken, getSettings }) {
  const [prevData, setPrevData] = useState(settings);

  const [formData, setData] = useState({
    commission_type: settings?.commission_type || "",
    percentage_commission: settings?.percentage_commission || "",
    flat_rate_commission: settings?.flat_rate_commission || "",
    cancellation_fee: settings?.cancellation_fee || "",
    cancellation_fee_type: settings?.cancellation_fee_type || "",
    tax: settings?.tax || "",
    tax_type: settings?.tax_type || "",
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (settings) {
      setPrevData(settings);
      setData({
        commission_type: settings?.commission_type || "",
        percentage_commission: settings?.percentage_commission || "",
        flat_rate_commission: settings?.flat_rate_commission || "",
        cancellation_fee: settings?.cancellation_fee || "",
        cancellation_fee_type: settings?.cancellation_fee_type || "",
        tax: settings?.tax || "",
        tax_type: settings?.tax_type || "",
      });
    }
  }, [settings]);

  const handleChange = (e) => {
    setData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setIsLoading(true);
    updatePlatformFees(formData, accessToken, () => {
      getSettings(accessToken, () => {
        setIsLoading(false);
      });
    });
  };

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="sectionHeight--mid">
        <div className="row">
          <div className="col-lg-7">
            <form className="py-3 px-2" onSubmit={handleSubmit}>
              <div className="mt-3 mb-3">
                <InputField
                  label="Platform Commission (%)"
                  name="percentage_commission"
                  type="number"
                  value={formData?.percentage_commission}
                  onChange={handleChange}
                />
              </div>

              <div className="mt-3 mb-3">
                <p className="sectionText textIsBold--semi mb-1 lAlign">Taxes *</p>
                <div className="row mx-0">
                  <div className="col-8 px-0 pr-2">
                    <InputField
                      name="tax"
                      type="number"
                      value={formData?.tax}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-4 px-0 pl-2">
                    <div className="input__custom alignOnly w-100">
                      <select
                        className="w-100 border-0 bg-transparent sectionText textIsGray"
                        name="tax_type"
                        value={formData?.tax_type || "percentage"}
                        onChange={handleChange}
                        style={{ outline: "none" }}
                      >
                        <option value="percentage">Percentage (%)</option>
                        <option value="flat">Fiat / Flat Rate</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-3 mb-3">
                <p className="sectionText textIsBold--semi mb-1 lAlign">Cancellation Penalty *</p>
                <div className="row mx-0">
                  <div className="col-8 px-0 pr-2">
                    <InputField
                      name="cancellation_fee"
                      type="number"
                      value={formData?.cancellation_fee}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-4 px-0 pl-2">
                    <div className="input__custom alignOnly w-100">
                      <select
                        className="w-100 border-0 bg-transparent sectionText textIsGray"
                        name="cancellation_fee_type"
                        value={formData?.cancellation_fee_type || "percentage"}
                        onChange={handleChange}
                        style={{ outline: "none" }}
                      >
                        <option value="percentage">Percentage (%)</option>
                        <option value="flat">Fiat / Flat Rate</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-4">
                {isLoading ? (
                  <button className="btn__filled textIsBold alignOnly" disabled>
                    Please Wait {""}
                    <Spinner />
                  </button>
                ) : (
                  <button className="btn__filled textIsBold">
                    Save Changes
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  settings: state.admin.settings,
  accessToken: state.admin.token,
});

const mapDispatchToProps = (dispatch) => ({
  updatePlatformFees: (data, token, success) =>
    dispatch(update_platform_fees(data, token, success)),
  getSettings: (token, success) => dispatch(get_settings(token, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Fees);
